import { render } from "./DialogLou.vue?vue&type=template&id=625b2888"
import script from "./DialogLou.vue?vue&type=script&lang=js"
export * from "./DialogLou.vue?vue&type=script&lang=js"
script.render = render

export default script